module.exports = __webpack_public_path__ + "static/media/four.bca8d910.svg";